
import Cruise from "../assets/cruise_.png";
import Bestprice from '../assets/bestprice_.png';
import Booking from '../assets/booking_.png';
import Zero from '../assets/zero_.png';

const data = [
    {
        img:Cruise,
        heading:"First to bring Cruising to India",
        para:"30+ years of pioneering cruising with the Royal Caribbean Group"
    },
    {
        img:Bestprice,
        heading:"Best Price Guarantee",
        para:"We don’t just match cruise fares- we beat them! So you can book with confidence."
    },
    {
        img:Zero,
        heading:"Zero Service Charge",
        para:"Multiple payment options with credit and debit cards, EMIs, wallets and bank transfers , and you get our expertise for No service charge"
    },
    {
        img:Booking,
        heading:"Dedicated Customer Support",
        para:"Enjoy personalized assistance at every step of your cruise journey with our dedicated customer support team—ready to help, anytime you need."
    }
]

export default data ;